import { initializeApp } from "firebase/app";
import {
  getAuth, GoogleAuthProvider, signInWithPopup, signOut,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable, type HttpsCallableOptions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(config);
export const auth = getAuth(app);
/*
 * SEM cache persistente de proposito (Tiago, 01/09): dado fiscal nunca pode
 * aparecer desatualizado, nem por um instante. So o basico da conta e
 * lembrado (localStorage, em App.tsx) para pintar a moldura na hora; o
 * conteudo vem sempre fresco do servidor, com esqueleto enquanto chega.
 */
export const db = getFirestore(app);
export const functions = getFunctions(app, "southamerica-east1");
export const storage = getStorage(app);

/**
 * Modo exclusivo para produzir a documentação visual com a aplicação real.
 * As duas travas são intencionais: não existe fora do servidor de
 * desenvolvimento e exige que todo o Firebase esteja apontado aos emuladores.
 */
export const MODO_DOCUMENTACAO = import.meta.env.DEV
  && import.meta.env.VITE_EMULADORES === "1"
  && import.meta.env.VITE_DOCUMENTACAO === "1";

const moduloDocumentacao = MODO_DOCUMENTACAO
  ? import("./firebase.documentacao.js")
  : undefined;

// A conexão precisa existir antes de qualquer listener de autenticação. O
// módulo inteiro é eliminado quando DEV é falso no build publicado.
if (moduloDocumentacao) {
  const { conectarFirebaseDocumentacao } = await moduloDocumentacao;
  conectarFirebaseDocumentacao({ auth, db, functions, storage });
}

export function entrarComGoogle() {
  const provedor = new GoogleAuthProvider();
  provedor.setCustomParameters({ prompt: "select_account" });
  return signInWithPopup(auth, provedor);
}

let entradaDocumentacao: Promise<void> | undefined;
export async function entrarModoDocumentacao(): Promise<void> {
  if (!MODO_DOCUMENTACAO) return;
  if (!entradaDocumentacao) {
    const onboarding = new URLSearchParams(window.location.search)
      .get("cenario") === "onboarding";
    entradaDocumentacao = moduloDocumentacao!
      .then(({ entrarContaDocumentacao }) => entrarContaDocumentacao({ auth, onboarding }))
      .finally(() => { entradaDocumentacao = undefined; });
  }
  await entradaDocumentacao;
}

export const sair = () => signOut(auth);

export function chamar<Entrada, Saida>(nome: string, opcoes?: HttpsCallableOptions) {
  return async (dados: Entrada): Promise<Saida> => {
    const fn = httpsCallable<Entrada, Saida>(functions, nome, opcoes);
    return (await fn(dados)).data;
  };
}
